<div class="wrapper">
    <div class="app-table-row flex-row">
        <div class="app-table-cell icon-column">
            <div>
                <img class="leaderboard-icon" ngSrc="/assets/images/svg/leaderboard.svg" height="24" width="24" alt="Engagement Score">
            </div>
        </div>
        <div class="app-table-cell">
            <div class="app-table">
                <div class="app-table-row">
                    <div class="app-table-cell">
                        <div class="profile-label score">
                            <strong>Engagement Score</strong>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="app-table-row flex-row">
        <div class="app-table-cell icon-column"></div>
        <div class="app-table-cell">
            <ng-container *ngFor="let profile of leadScoreProfiles()">
                <div class="app-table-row">
                    <div class="app-table-cell app-vertical-align-middle">
                        <span class="rating-label">{{profile.profileName}}</span>
                    </div>
                    <div class="app-table-cell rating-icon">
                        <nova-rating-name [ratingId]="profile?.ratingId" [showName]="false">
                        </nova-rating-name>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
